import { useWidgetAdaptiveText } from '../../../hooks';

import styles from './GeneralWidgetTimer.module.scss';

interface GeneralWidgetTimerProps {
  timerValue: string;
  extended?: boolean;
  dataTestId?: string;
}

export function GeneralWidgetTimer(props: GeneralWidgetTimerProps) {
  const { timerValue, extended, dataTestId } = props;
  const { textRef } = useWidgetAdaptiveText({ padding: 4 });
  return (
    <div className={extended ? styles.containerExtended : styles.container} data-testid={dataTestId}>
      <span ref={textRef} className={extended ? styles.textExtended : styles.text}>
        {timerValue}
      </span>
    </div>
  );
}
